import { BASE_DOMAIN } from './constant'
import { Network } from './JDTGateway'
import type { FetchOptions } from './types'
import { queryPurify } from '@/utils/params'

const BASE_PATH = '/gw2/generic/shopwallet/newh5/m/'
const BASE_URL = BASE_DOMAIN + BASE_PATH

// 公共参数
export const commonParams = {
  h5Version: '2.0.1'
}

/** 通用的入参整理 */
function tidyData(options: FetchOptions) {
  // 解析参数
  const { params = {}, encrypt = false } = options || {}
  console.log('fetch tidyData:', params)
  // 返回处理好的接口配置信息
  return {
    ...options,
    params: queryPurify({ ...commonParams, ...params }),
    encrypt
  }
}

/** 导出科技网关请求方法 */
export async function JdtFetch(options: FetchOptions = {}) {
  /** 配置校验 */
  if (typeof options != 'object') return

  /** 通用入参处理 */
  options = tidyData(options)

  /** 是否需要初始化公钥 */
  if (options.encrypt && !window.PUBKEY) await getPubkey()

  /** 配置请求的公共路径 */
  Network.setConfig({
    baseURL: BASE_URL
  })

  /** 调用接口 */
  return Network.exec(options)
}

/** 获取公钥 */
export async function getPubkey() {
  return Network.initPubKey()
}

/** 切量接口请求封装
 * @param {*} name 接口名
 * @param {*} options 选项配置
 */
export async function fetch(path: string, options: FetchOptions = {}) {
  // 根据接口名获取配置的接口路径
  return JdtFetch({ ...options, url: path || '' })
}
